module.exports = __webpack_public_path__ + "img/totem.36814577.png";